import React, { lazy, Suspense, useEffect, useState } from 'react';
import HeroSection from './HeroSection';

const HomeContent = lazy(() => import('./HomeContent'));

export default function Home() {
  const [contentReady, setContentReady] = useState(false);

  useEffect(() => {
    let timer = 0;
    const revealContent = () => {
      // This content begins below the opening viewport. Load its interaction
      // runtime after the critical hero resources have received priority.
      timer = window.setTimeout(() => setContentReady(true), 120);
    };

    if (document.readyState === 'complete') {
      revealContent();
    } else {
      window.addEventListener('load', revealContent, { once: true });
    }

    return () => {
      window.removeEventListener('load', revealContent);
      if (timer) window.clearTimeout(timer);
    };
  }, []);

  return (
    <>
      <HeroSection />
      {contentReady ? (
        <Suspense fallback={<div className="home-content-loading" aria-hidden="true" />}>
          <HomeContent />
        </Suspense>
      ) : <div className="home-content-loading" aria-hidden="true" />}
    </>
  );
}
